
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { getVersionList, setCurrentVersion } from '@/api/version';
import Edit from './edit.vue';
import { toast } from '@/utils/common';
import { eUpdateType, eUpdateVersion, iVersion, iVersionSearch } from '@/interface/version';
import { PageQuery } from '@/mixins/page_query';
import { eEndPoint } from '@/interface/hot-game';
@Component({
  components: { Edit },
})
export default class HotGame extends Mixins(PageQuery) {
  tableModel: iVersion[] = [];
  loading: boolean = false;
  visible: boolean = false;
  andriod: eUpdateVersion = eUpdateVersion.ANDRIOD;
  ios: eUpdateVersion = eUpdateVersion.IOS;
  no: eUpdateVersion = eUpdateVersion.NO;
  seletUpdate: eUpdateType = eUpdateType.SELECTUPDATE;
  select: eUpdateType = eUpdateType.SELECT;
  model: iVersion = {
    id: 0,
    scope: this.andriod,
    version: '',
    change_log: [],
    update_type: eUpdateType.SELECT,
    created_at: '',
    current: false,
  };
  route_type: number = 0;
  ActFree: number = -1;
  total: number = 0;
  exitTitle: string = '新增版本';
  searchInfo: iVersionSearch = {
    search_key: '',
    scope: this.andriod,
  };

  /* 查询 */
  searchList() {
    // this.page_query.page = 1;
    this.getList();
  }
  /* 编辑 */
  editRow(row: iVersion) {
    this.clear();
    this.visible = true;

    this.model = row;
    this.exitTitle = '编辑版本';
  }
  addVersion() {
    this.clear();
    this.visible = true;
    this.exitTitle = '新增版本';
  }
  getChangeLog(list: any) {
    let str = '';
    list.forEach((item: any) => {
      str += '<div>' + item + '</div>';
    });

    return str;
  }
  async getList() {
    this.loading = true;
    try {
      const query = {
        ...this.page_query,
        ...this.searchInfo,
      };
      const res = await getVersionList(query);

      if (res && res.code == 0) {
        this.tableModel = res.data.list;
        this.total = res.data.total;
        this.loading = false;
      }
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  }

  /* 设置为该版本号 */
  async setVersion(row: any) {
    const { version, id } = row;
    this.$msgbox({
      title: '提示',
      message: '是否确认设置该版本:' + version + ',为当前版本？',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true;
          instance.confirmButtonText = '执行中...';
          this.loading = true;
          const obj = { id: id, scope: this.searchInfo.scope };
          const res: any = await setCurrentVersion(obj);
          done();
          if (res && res.code == 0) {
            toast('操作成功');
            this.loading = false;
            this.searchList();
          }
          instance.confirmButtonLoading = false;
          this.loading = false;
        } else if (action === 'cancel') {
          done();
          instance.confirmButtonLoading = false;
          this.loading = false;
        }
      },
    })
      .then(() => {})
      .catch((err: any) => {
        console.log(err);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  clear() {
    this.model = {
      id: 0,
      version: '',
      change_log: [],
      update_type: eUpdateType.SELECTUPDATE,
      created_at: '',
      current: false,
      scope: this.andriod,
    };
  }
  editOk() {
    this.clear();
    this.getList();
    this.visible = false;
  }

  mounted() {
    this.pageFn = this.searchList;
    this.searchList();
  }
  // @Watch('$route.meta.type')
  // onChangeValue(newVal: number, oldVal: number) {
  //   if (newVal != oldVal) {
  //     this.route_type = newVal;
  //     if (this.route_type == eEndPoint.ADNROID) {
  //       this.model.scope = this.andriod;
  //       this.searchInfo.scope = this.andriod;
  //     } else {
  //       if (this.route_type == eEndPoint.IOS) {
  //         this.model.scope = this.ios;
  //         this.searchInfo.scope = this.ios;
  //       }
  //     }
  //     this.searchList();
  //   }
  // }
}
